// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"4c8b5051","265":"b054df61","453":"8701dc61","590":"bfce1620","625":"09b527f1","686":"3654fdc2","876":"8c751681","896":"1a4ff403","936":"5a01b575"}[chunkId] + ".chunk.js";
};